import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-4xl font-bold">404 - Page non trouvée</h1>
      <p className="text-gray-600">La page que vous cherchez n'existe pas.</p>
      <Link to="/" className="mt-4 text-green-800 hover:underline">
        Retour à la page d'accueil
      </Link>
    </div>
  );
};

export default NotFound;
